import React from "react";
import { Text } from "react-native";
import type { Meta, StoryObj } from "@storybook/react";
import { BodyMediumText } from "../../components/FormattedText";
import { Bubble } from "../../components/Bubble";

function BubbleStoryComponent() {
    return (
        <Bubble title="Titre de bulle">
            <BodyMediumText>Texte de bulle</BodyMediumText>
        </Bubble>
    );
}

const meta = {
    title: "Atom/Bubble",
    component: BubbleStoryComponent,
    argTypes: {},
} satisfies Meta<typeof BubbleStoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Basic: Story = {
    args: {},
};
